import { IconProps } from "./Icons";

export const IconMountains = ({
  width = 94,
  height = 94,
  isHovered = false,
}: IconProps) => {
  if (isHovered) {
    return (
      <svg
        width="41"
        height="41"
        viewBox="0 0 41 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_44_1321)">
          <path
            d="M40.7395 31.5266L32.2145 17.1391C31.9947 16.7643 31.6802 16.4538 31.3026 16.2388C30.925 16.0238 30.4975 15.9119 30.063 15.9141C29.6287 15.9118 29.2014 16.0238 28.824 16.2388C28.4466 16.4538 28.1325 16.7643 27.913 17.1391L23.8255 24.0391L16.8192 12.1485C16.5985 11.7732 16.2835 11.4622 15.9056 11.2461C15.5277 11.0299 15.0999 10.9163 14.6645 10.9163C14.2292 10.9163 13.8014 11.0299 13.4235 11.2461C13.0456 11.4622 12.7306 11.7732 12.5099 12.1485L1.08797 31.5297C0.976173 31.7195 0.916523 31.9355 0.915066 32.1558C0.91361 32.3761 0.970398 32.5929 1.07968 32.7842C1.18896 32.9754 1.34685 33.1344 1.53737 33.2451C1.72788 33.3557 1.94424 33.414 2.16454 33.4141H39.6645C39.8852 33.414 40.1019 33.3556 40.2926 33.2447C40.4833 33.1338 40.6413 32.9744 40.7505 32.7827C40.8597 32.591 40.9162 32.3738 40.9143 32.1532C40.9123 31.9325 40.8521 31.7164 40.7395 31.5266ZM14.6645 13.4141L18.3474 19.6641H10.9817L14.6645 13.4141ZM4.35204 30.9141L9.50829 22.1641H19.8208L22.7489 27.1328L24.977 30.9141H4.35204ZM27.8786 30.9141L25.2755 26.4953L30.063 18.4141L37.477 30.9141H27.8786Z"
            fill="white"
          />
        </g>
        <path
          d="M30.8994 9.125C30.8994 6.63972 28.8847 4.625 26.3994 4.625C23.9141 4.625 21.8994 6.63972 21.8994 9.125C21.8994 11.6103 23.9141 13.625 26.3994 13.625C28.8847 13.625 30.8994 11.6103 30.8994 9.125ZM24.1318 9.125C24.1318 7.87265 25.1471 6.85743 26.3994 6.85743C27.6518 6.85743 28.667 7.87265 28.667 9.125C28.667 10.3773 27.6518 11.3926 26.3994 11.3926C25.1471 11.3926 24.1318 10.3773 24.1318 9.125Z"
          fill="#D9D9D9"
        />
        <defs>
          <clipPath id="clip0_44_1321">
            <rect
              width={width}
              height={height}
              fill="white"
              transform="translate(0.915039 0.914062)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  } else {
    return (
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4295_19685)">
          <path
            d="M40.5999 30.6125L32.0749 16.225C31.855 15.8502 31.5405 15.5398 31.1629 15.3248C30.7853 15.1098 30.3578 14.9978 29.9233 15C29.489 14.9978 29.0617 15.1097 28.6844 15.3248C28.307 15.5398 27.9928 15.8502 27.7733 16.225L23.6858 23.125L16.6796 11.2344C16.4588 10.8592 16.1439 10.5481 15.766 10.332C15.388 10.1159 14.9602 10.0022 14.5249 10.0022C14.0895 10.0022 13.6617 10.1159 13.2838 10.332C12.9059 10.5481 12.591 10.8592 12.3702 11.2344L0.948326 30.6156C0.836525 30.8055 0.776875 31.0215 0.775418 31.2418C0.773961 31.462 0.83075 31.6788 0.940031 31.8701C1.04931 32.0614 1.20721 32.2204 1.39772 32.331C1.58823 32.4416 1.80459 32.4999 2.02489 32.5H39.5249C39.7455 32.5 39.9622 32.4415 40.1529 32.3307C40.3437 32.2198 40.5017 32.0604 40.6109 31.8686C40.7201 31.6769 40.7766 31.4597 40.7746 31.2391C40.7727 31.0185 40.7124 30.8023 40.5999 30.6125ZM14.5249 12.5L18.2077 18.75H10.8421L14.5249 12.5ZM4.21239 30L9.36864 21.25H19.6811L22.6093 26.2188L24.8374 30H4.21239ZM27.739 30L25.1358 25.5813L29.9233 17.5L37.3374 30H27.739Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_4295_19685">
            <rect
              width={width}
              height={height}
              fill="white"
              transform="translate(0.775391)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
};
